export default String.raw`
<nav class="header-nav header-nav-js">
    <ul class="header-nav__list header-nav-list-js">
        {% if usr.Authenticated or notAuth -%}
            <li style="order: -1;">
                <button class="header-nav__btn toggle-categories-js header-categories-js" aria-label="{{ translations.Categories }}" title="{{ translations.Categories }}">
                    <svg height="24" width="24" class="header-nav__btn-icon">
                        <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#bars-{{settings.iconStyle}}"></use>
                    </svg>
                    <span>{{translations.Categories}}</span>
                    <svg height="24" width="24" class="header-nav__mobile-icon">
                        <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#chevron-down-{{settings.iconStyle}}"></use>
                    </svg>
                </button>
            </li>
        {% endif -%}
        {% assign manufacturersSize = manufacturer-brand.Manufacturers | Size -%}
        {% if usr.Authenticated == true -%}
            {% if settings.documents -%}
                <li style="order: {{settings.documentsNo}};">
                    {% capture documentsHref -%}{% include 'partials/common/user-link.html', userLink: settings.documentsLink -%}{% endcapture -%}
                    <a href="{{ documentsHref }}" class="header-nav__btn">
                        <span>
                            {% if settings.documentsTranslation != '' -%}
                                {{ translations[settings.documentsTranslation] }}
                            {% else -%}
                                {{ settings.documentsLabel }}
                            {% endif -%}
                        </span>
                    </a>
                </li>
            {% endif -%}
            {% assign manufacturers = settings.authenticatedManufacturers -%}
            {% assign manufacturersNo = settings.authenticatedManufacturersNo -%}
            {% assign manufacturersIcon = settings.authenticatedManufacturersIcon -%}
            {% assign manufacturersLabel = settings.authenticatedManufacturersLabel -%}
            {% assign manufacturersTranslation = settings.authenticatedManufacturersTranslation -%}
            {% assign manufacturersLink = settings.authenticatedManufacturersLink -%}
            {% assign lookbook = settings.authenticatedLookbook -%}
            {% assign lookbookNo = settings.authenticatedLookbookNo -%}
            {% assign lookbookIcon = settings.authenticatedLookbookIcon -%}
            {% assign lookbookLabel = settings.authenticatedLookbookLabel -%}
            {% assign lookbookTranslation = settings.authenticatedLookbookTranslation -%}
            {% assign lookbookLink = settings.authenticatedLookbookLink -%}
            {% assign searchAdvanced = settings.authenticatedSearchAdvanced -%}
            {% assign searchAdvancedNo = settings.authenticatedSearchAdvancedNo -%}
            {% assign searchAdvancedIcon = settings.authenticatedSearchAdvancedIcon -%}
            {% assign searchAdvancedLabel = settings.authenticatedSearchAdvancedLabel -%}
            {% assign searchAdvancedTranslation = settings.authenticatedSearchAdvancedTranslation -%}
            {% assign searchAdvancedLink = settings.authenticatedSearchAdvancedLink -%}
            {% assign cartImport = settings.authenticatedCartImport -%}
            {% assign cartImportNo = settings.authenticatedCartImportNo -%}
            {% assign cartImportIcon = settings.authenticatedCartImportIcon -%}
            {% assign cartImportLabel = settings.authenticatedCartImportLabel -%}
            {% assign cartImportTranslation = settings.authenticatedCartImportTranslation -%}
            {% assign cartImportLink = settings.authenticatedCartImportLink -%}
            {% assign downloadCSV = settings.authenticatedDownloadCSV -%}
            {% assign downloadCSVNo = settings.authenticatedDownloadCSVNo -%}
            {% assign downloadCSVIcon = settings.authenticatedDownloadCSVIcon -%}
            {% assign downloadCSVLabel = settings.authenticatedDownloadCSVLabel -%}
            {% assign downloadCSVTranslation = settings.authenticatedDownloadCSVTranslation -%}
            {% assign downloadCSVLink = settings.authenticatedDownloadCSVLink -%}
            {% assign customerLinks = settings.authenticatedCustomerLinks -%}
        {% else -%}
            {% assign manufacturers = settings.notAuthenticatedManufacturers -%}
            {% assign manufacturersNo = settings.notAuthenticatedManufacturersNo -%}
            {% assign manufacturersIcon = settings.notAuthenticatedManufacturersIcon -%}
            {% assign manufacturersLabel = settings.notAuthenticatedManufacturersLabel -%}
            {% assign manufacturersTranslation = settings.notAuthenticatedManufacturersTranslation -%}
            {% assign manufacturersLink = settings.notAuthenticatedManufacturersLink -%}
            {% assign lookbook = settings.notAuthenticatedLookbook -%}
            {% assign lookbookNo = settings.notAuthenticatedLookbookNo -%}
            {% assign lookbookIcon = settings.notAuthenticatedLookbookIcon -%}
            {% assign lookbookLabel = settings.notAuthenticatedLookbookLabel -%}
            {% assign lookbookTranslation = settings.notAuthenticatedLookbookTranslation -%}
            {% assign lookbookLink = settings.notAuthenticatedLookbookLink -%}
            {% assign searchAdvanced = settings.notAuthenticatedSearchAdvanced -%}
            {% assign searchAdvancedNo = settings.notAuthenticatedSearchAdvancedNo -%}
            {% assign searchAdvancedIcon = settings.notAuthenticatedSearchAdvancedIcon -%}
            {% assign searchAdvancedLabel = settings.notAuthenticatedSearchAdvancedLabel -%}
            {% assign searchAdvancedTranslation = settings.notAuthenticatedSearchAdvancedTranslation -%}
            {% assign searchAdvancedLink = settings.notAuthenticatedSearchAdvancedLink -%}
            {% assign cartImport = settings.notAuthenticatedCartImport -%}
            {% assign cartImportNo = settings.notAuthenticatedCartImportNo -%}
            {% assign cartImportIcon = settings.notAuthenticatedCartImportIcon -%}
            {% assign cartImportLabel = settings.notAuthenticatedCartImportLabel -%}
            {% assign cartImportTranslation = settings.notAuthenticatedCartImportTranslation -%}
            {% assign downloadCSV = settings.notAuthenticatedDownloadCSV -%}
            {% assign downloadCSVNo = settings.notAuthenticatedDownloadCSVNo -%}
            {% assign downloadCSVIcon = settings.notAuthenticatedDownloadCSVIcon -%}
            {% assign downloadCSVLabel = settings.notAuthenticatedDownloadCSVLabel -%}
            {% assign downloadCSVTranslation = settings.notAuthenticatedDownloadCSVTranslation -%}
            {% assign customerLinks = settings.notAuthenticatedCustomerLinks -%}
        {% endif -%}
        {% assign manufacturersSize = manufacturer-brand.Manufacturers | Size -%}
        {% if manufacturers and manufacturersSize > 0 -%}
            <li style="order: {{manufacturersNo}};">
                {% if page.PageId == config.DefinedPages.Manufacturers.Id -%}
                    <span class="header-nav__btn">
                {% else -%}
                    {% capture manufacturersHref -%}{% include 'partials/common/user-link.html', userLink: manufacturersLink -%}{% endcapture -%}
                    <a href="{{ manufacturersHref }}" class="header-nav__btn">
                {% endif -%}
                        <span>
                            {% if manufacturersTranslation != '' -%}
                                {{ translations[manufacturersTranslation] }}
                            {% else -%}
                                {{ manufacturersLabel }}
                            {% endif -%}
                        </span>
                {% if page.PageId != config.DefinedPages.Manufacturers.Id -%}
                    </a>
                {% else -%}
                    </span>
                {% endif -%}
            </li>
        {% endif -%}
        {% if lookbook -%}
            <li style="order: {{lookbookNo}};">
                {% if config.DefinedPages.Lookbook.Id == page.PageId -%}
                    <span class="header-nav__btn">
                {% else -%}
                    {% capture lookbookHref -%}{% include 'partials/common/user-link.html', userLink: lookbookLink -%}{% endcapture -%}
                    <a href="{{ lookbookHref }}" class="header-nav__btn">
                {% endif -%}
                        <span>
                            {% if lookbookTranslation != '' -%}
                                {{ translations[lookbookTranslation] }}
                            {% else -%}
                                {{ lookbookLabel }}
                            {% endif -%}
                        </span>
                {% if config.DefinedPages.Lookbook.Id != page.PageId -%}
                    </a>
                {% else -%}
                    </span>
                {% endif -%}
            </li>
        {% endif -%}
        {% if searchAdvanced -%}
            <li style="order: {{searchAdvancedNo}};">
                {% if config.DefinedPages.AdvancedSearch.Id == page.PageId -%}
                    <span class="header-nav__btn">
                {% else -%}
                    {% capture searchAdvancedHref -%}{% include 'partials/common/user-link.html', userLink: searchAdvancedLink -%}{% endcapture -%}
                    <a href="{{ searchAdvancedHref }}" class="header-nav__btn">
                {% endif -%}
                        <span>
                            {% if searchAdvancedTranslation != '' -%}
                                {{ translations[searchAdvancedTranslation] }}
                            {% else -%}
                                {{ searchAdvancedLabel }}
                            {% endif -%}
                        </span>
                {% if config.DefinedPages.AdvancedSearch.Id != page.PageId -%}
                    </a>
                {% else -%}
                    </span>
                {% endif -%}
            </li>
        {% endif -%}
        {% if cartImport and config.B2B -%}
            <li style="order: {{cartImportNo}};">
                <label tabindex="0" role="button" for="file" class="import-cart-js header-nav__btn">
                    {% if cartImportTranslation != '' -%}
                        {{ translations[cartImportTranslation] }}
                    {% else -%}
                        {{ cartImportLabel }}
                    {% endif -%}
                </label>
                <input tabindex="-1" class="import-cart-input-js" id="file" type="file" name="file" accept=".csv" >

                <div class="during-ajax-modal-js during-ajax-modal hidden-js">
                    {% comment -%} Could be moved to base layout {% endcomment -%}
                    <div class="loader big"></div>
                </div>
            </li>
        {% endif -%}
        {% if downloadCSV and config.B2B -%}
            <li style="order: {{downloadCSVNo}};">
                <a href="{{ page.BaseHref }}usr/cart_importcsv_file.csv" class="header-nav__btn">
                    {% if downloadCSVTranslation != '' -%}
                        {{ translations[downloadCSVTranslation] }}
                    {% else -%}
                        {{ downloadCSVLabel }}
                    {% endif -%}
                </a>
            </li>
        {% endif -%}
        {% for customerLink in customerLinks -%}
            {% if customerLink.available -%}
                <li style="order: {{customerLink.no}};">
                    {% capture customerLinkHref -%}{% include 'partials/common/user-link.html', userLink: customerLink.link -%}{% endcapture -%}
                    <a href="{{ customerLinkHref }}" class="header-nav__btn">
                        <span>
                            {% if customerLink.translation != '' -%}
                                {{ translations[customerLink.translation] }}
                            {% else -%}
                                {{ customerLink.label }}
                            {% endif -%}
                        </span>
                    </a>
                </li>
            {% endif -%}
        {% endfor -%}
        <li class="header-nav__btn dots header-nav-dots-btn-js toggle-dropdown-js hidden-js" data-container=".header-nav-dots-btn-js">
            <button aria-label="{{ translations.More }}">
                <svg height="24" width="24">
                    <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#ellipsis-h-{{settings.iconStyle}}"></use>
                </svg>
            </button>
            <div class="header__dropdown header-nav__dropdown dropdowns-js dropdown-js hidden-js">
                <ul class="header__dropdown-list header-menu-dropdown-js">
                </ul>
            </div>
        </li>
    </ul>
    {% if page.PageId == config.DefinedPages.Order.Id -%}
        <div class="add-to-cart-from-cart-js" style="display: none" data-url="{{ page.BaseHref }}{{ config.DefinedPages.Order.Url }}" data-message="{% if customer.Cart.EditedOrderId -%}{{ translations.AddedToOrder }}{% else -%}{{ translations.AddedToCart }}{% endif -%}"></div>
    {% endif -%}
</nav>

`